/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';
import line from '../../../img/line-white.svg';

import styles from '../../../styles/partials/splash.module.scss';

const propTypes = {
    tagline: PropTypes.string,
    delay: PropTypes.number,
    // duration: PropTypes.number,
    stagger: PropTypes.number,
    className: PropTypes.string,
    children: PropTypes.node,
};

const defaultProps = {
    tagline: null,
    delay: 200,
    // duration: 500,
    stagger: 40,
    className: null,
    children: null,
};

const Splash = ({ tagline, delay, stagger, className, children }) => {
    const [active, setActive] = useState(false);
    const timer = useRef(null);
    useEffect(() => {
        timer.current = setTimeout(() => {
            setActive(true);
        }, delay);

        return () => {
            if (timer.current !== null) {
                clearTimeout(timer.current);
                timer.current = null;
            }
        };
    }, [delay]);

    const words = useMemo(
        () =>
            (tagline || '').split(' ').map((word, wordIndex) => (
                <div key={`word-${wordIndex}`} className={styles.word}>
                    {word.split('').map((letter, letterI) => (
                        <div
                            className={styles.letter}
                            key={`letter-${letterI}`}
                            style={{
                                transitionDelay: `${
                                    wordIndex * (word.length * 20) + letterI * stagger
                                }ms`,
                                // transitionDuration: `${duration}ms`,
                            }}
                        >
                            {letter}
                        </div>
                    ))}
                </div>
            )),
        [tagline],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.enter]: active,
                    [className]: className !== null,
                },
            ])}
        >
            {/* <div className={styles.inner}> */}
            <div className={styles.wordsContainer}>
                <div className={styles.words}>
                    {words}
                    <img className={styles.line} src={line} alt="Ligne" />
                </div>
            </div>
            {/* </div> */}
            {children}
        </div>
    );
};

Splash.propTypes = propTypes;
Splash.defaultProps = defaultProps;

export default Splash;
